var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "viewer",
    { attrs: { images: _vm.images } },
    _vm._l(_vm.images, function(item) {
      return _c("img", {
        key: item.index,
        attrs: { src: item.src, height: "25px", width: "50px" }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }